// Auto push-notification prompt. On login, if the browser supports push,
// permission isn't denied, and the user isn't already subscribed, ask once
// (per browser session) whether to enable push. Clicking 开启 triggers the
// real browser permission prompt via subscribeToPush() (needs the click gesture).

import { useEffect, useState } from 'react';
import * as push from '../lib/push.ts';
import { Modal } from './Modal.jsx';

const PROMPTED_KEY = 'vava.push-prompted';

export const PushPrompt = ({ user }) => {
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  useEffect(() => {
    if (!user) return;
    let cancelled = false;
    (async () => {
      try {
        if (sessionStorage.getItem(PROMPTED_KEY)) return;     // asked already this session
        if (!push.pushSupported()) return;                    // unsupported browser
        if (push.pushPermission() === 'denied') return;       // user previously blocked
        const sub = await push.getExistingSubscription().catch(() => null);
        if (sub) return;                                      // already subscribed
        if (!cancelled) setShow(true);
      } catch { /* never block the app on the prompt */ }
    })();
    return () => { cancelled = true; };
  }, [user?.id]);

  function dismiss() {
    try { sessionStorage.setItem(PROMPTED_KEY, '1'); } catch { /* ignore */ }
    setShow(false);
  }

  async function enable() {
    setBusy(true); setErr('');
    try {
      const ok = await push.subscribeToPush();
      if (ok) dismiss();
      else { setErr('未能开启（可能被浏览器拒绝）'); setBusy(false); }
    } catch (e) {
      setErr(e?.message || '开启失败'); setBusy(false);
    }
  }

  if (!show) return null;
  return (
    <Modal
      title="开启推送通知"
      onClose={dismiss}
      width={400}
      footer={
        <>
          <button className="btn btn-secondary" onClick={dismiss} disabled={busy}>暂不</button>
          <button className="btn btn-primary" onClick={enable} disabled={busy} autoFocus>
            {busy ? '开启中…' : '开启推送'}
          </button>
        </>
      }>
      <div style={{ fontSize: 14, lineHeight: 1.6, color: 'var(--vava-text)' }}>
        开启后，待办分配、@提及、低库存等会实时推送到这台设备，不用一直盯着页面。
        随时可在右上角铃铛里关闭。
        {err && <div className="att-error" style={{ marginTop: 10 }}>{err}</div>}
      </div>
    </Modal>
  );
};
